import { Question } from "../../interfaces/purchase-order.interface";
import { EntitiesQuestions } from "./entities.questions";
import { cloneDeep } from "lodash";

export class InfractionsQuestion {
  public static questions_infractions_payment: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "select",
      question: "Selecciona a qué entidad pertenece el comprobante",
      control: "belong_city",
      options: cloneDeep(EntitiesQuestions.question_entities),
      page: 1,
    },
    {
      type: "radio",
      question: "¿Los datos de la infracción coinciden con lo mostrado en el sistema al consultar?",
      control: "infraction_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Gestiona el pago de la multa, y carga las evidencias.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿La infracción está pagada correctamente?",
      control: "payment_correct",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text:
              "Aclara la situacion con la agencia o con la entidad gubernamental correspondiente y carga el documento que mejor se ajuste a la resolución obtenida.",
          },
        },
      ],
      page: 2,
    },
  ];

  public static questions_infraction: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "select",
      question: "Selecciona a qué entidad pertenece el comprobante",
      control: "belong_city",
      options: cloneDeep(EntitiesQuestions.question_entities),
      page: 1,
    },
    {
      type: "radio",
      question: "¿Los datos de la infracción coinciden con lo mostrado en el sistema al consultar?",
      control: "infraction_valid",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "Gestiona el pago de la multa, y carga las evidencias.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿Necesitas el comprobante de pago? ",
      control: "need_payment",
      options: [
        {
          label: "Sí, pedir comprobante al Especialista",
          value: { value: "si", incident: false, incident_text: "Es necesario que se adjunte un comprobante pago." },
        },
        {
          label: "No, es una linea de captura",
          value: {
            value: "no",
            incident: false,
          },
        },
      ],
      page: 2,
    },
  ];
}
